import { LoaderOptions } from '@googlemaps/js-api-loader';

export const mapsConfig: LoaderOptions = Object.freeze({
  apiKey: process.env.VUE_APP_MAPS_API_KEY as string,
  version: 'quarterly',
  libraries: ['places', 'geometry']
});
